var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotentialGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_1254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2183 0C5.59127 0.00583409 0.22293 5.38292 0.228765 12.0105C0.234599 18.638 5.61169 24.0058 12.2392 24C18.8629 23.9942 24.2288 18.6234 24.2288 11.9998C24.2176 5.3732 18.8454 0.00583409 12.2183 0ZM17.1452 10.8072L17.135 10.8174L12.4677 19.2598C12.3822 19.4207 12.2144 19.5209 12.0321 19.5189H11.8867C11.668 19.4489 11.5231 19.2404 11.5343 19.0109L11.773 13.9804H7.728C7.55493 13.9785 7.39449 13.8885 7.3026 13.7417C7.21169 13.5881 7.21169 13.3975 7.3026 13.2439L11.9699 4.73923C12.0822 4.53115 12.3228 4.42808 12.5509 4.49031C12.7677 4.56323 12.9111 4.76986 12.9033 4.99836L12.6753 10.0288H16.7203C16.8997 10.0288 17.0635 10.1285 17.1457 10.2879C17.2536 10.444 17.2536 10.6506 17.1457 10.8067L17.1452 10.8072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_1254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.22876)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialGrow);
export default __webpack_public_path__ + "static/media/potential-grow.fab2fdcb2d30a016dfe06935ba83a4d8.svg";
export { ForwardRef as ReactComponent };